const DEFAULT_SETTLE_DELAY = 1500
const OBSERVER_ROOT_MARGIN = '200px 0px'
const timers = new WeakMap()
const observedTargets = new Set()
const reviewContainers = new WeakMap()

const observer =
  'IntersectionObserver' in window
    ? new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              return
            }

            observer.unobserve(entry.target)
            observedTargets.delete(entry.target)

            const container = reviewContainers.get(entry.target)

            reviewContainers.delete(entry.target)

            if (container) {
              mountProductReview(container)
            }
          })
        },
        { rootMargin: OBSERVER_ROOT_MARGIN },
      )
    : null

export function scheduleProductReview(container, { settleDelay = DEFAULT_SETTLE_DELAY } = {}) {
  if (!(container instanceof HTMLElement)) {
    return
  }

  cleanupDisconnectedTargets()

  const currentTimer = timers.get(container)

  if (currentTimer) {
    window.clearTimeout(currentTimer)
  }

  const timer = window.setTimeout(() => {
    timers.delete(container)

    if (!container.isConnected || container.dataset.productReviewsMounted === 'true') {
      return
    }

    const observationTarget = container.closest('.product-card')

    if (observer && observationTarget instanceof HTMLElement) {
      reviewContainers.set(observationTarget, container)
      observedTargets.add(observationTarget)
      observer.observe(observationTarget)

      return
    }

    mountProductReview(container)
  }, settleDelay)

  timers.set(container, timer)
}

function cleanupDisconnectedTargets() {
  if (!observer || observedTargets.size === 0) {
    return
  }

  observedTargets.forEach((target) => {
    if (target.isConnected) {
      return
    }

    observer.unobserve(target)
    observedTargets.delete(target)
    reviewContainers.delete(target)
  })
}

function mountProductReview(container) {
  if (!(container instanceof HTMLElement) || !container.isConnected || container.dataset.productReviewsMounted === 'true') {
    return
  }

  const widgetId = container.dataset.productReviewsWidgetId
  const sku = container.dataset.productReviewsSku

  if (!widgetId || !sku) {
    return
  }

  const widget = document.createElement('etrusted-widget')

  widget.dataset.etrustedWidgetId = widgetId
  widget.dataset.sku = sku

  container.dataset.productReviewsMounted = 'true'
  container.append(widget)
  container.classList.remove('d-none')
}
